import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';

export const AuthCheck = () => {
  const { asPath } = useRouter();
  const { getBaseUser } = useAuth();

  useEffect(() => {
    getBaseUser();
  }, [asPath]);

  useEffect(() => {
    function handlePageShow(event: PageTransitionEvent) {
      if (!event.persisted) return;

      getBaseUser();
    }

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  return null;
};
